import Home from "../screens/Home";
import Cadd from "../screens/Modules/cadd";
import Pme from "../screens/Modules/pme";

import View from "../screens/View";
import ViewCADD from '../screens/ViewCADD/index';
import Edit from "../screens/Edit/index";
import Analysis from "../screens/Analysis/index";
import EditCADD from '../screens/EditCADD/index';

import PMEProfile from "../screens/Modules/pme/screens/profile/index";
import TIFProfile from "../screens/Modules/tif/screens/profile/index";
import PMEStakeholder from "../screens/Modules/pme/screens/stakeholder/index";
import PMEStakeholderInfo from "../screens/Modules/pme/screens/stakeholder/info";
import PMELIR from "../screens/Modules/pme/screens/lir/index";
import PMELIRInfo from "../screens/Modules/pme/screens/lir/info";
import PMEScp from "../screens/Modules/pme/screens/scp/index";
import PMEScpInfo from "../screens/Modules/pme/screens/scp/info";
import PMEScl from "../screens/Modules/pme/screens/scl/index";
import PMESclInfo from "../screens/Modules/pme/screens/scl/info";
import PMEVillage from "../screens/Modules/pme/screens/villages/index";
import PMEVillageInfo from "../screens/Modules/pme/screens/villages/info";
import PMELocations from "../screens/Modules/pme/screens/locations/index";
import PMELocationsInfo from "../screens/Modules/pme/screens/locations/info";
import PMEUsers from "../screens/Modules/pme/screens/users/index";
import PMEEvents from "../screens/Modules/pme/screens/events/index";
import PMEEventsInfo from "../screens/Modules/pme/screens/events/info";
import PMEProjects from "../screens/Modules/pme/screens/projects/index";
import PMEProjectInfo from "../screens/Modules/pme/screens/projects/info";
import PMEProjectLoad from "../screens/Modules/pme/screens/projects/loader";
import PMEProjectPublications from "../screens/Modules/pme/screens/projects/publications";
import PMEStakeholderLocations from '../components/Forms/stakeholder/locations';
import PMEDUEDILIGINCE from "../screens/Modules/pme/screens/due-diligence/index";

import Profile from "../screens/Modules/cadd/screens/profile/index";
import KYC from "../screens/Modules/cadd/screens/kyc/index";
import CADDProjects from "../screens/Modules/cadd/screens/projects/index";
import CADDProjectInfo from "../screens/Modules/cadd/screens/projects/info";
import CADDProjectKYC from "../screens/Modules/cadd/screens/projects/kyc";
import CADDComplianceReport from "../screens/Modules/cadd/screens/compliance-report/index";
import CADDSupplyPolicy from "../screens/Modules/cadd/screens/sp/index";
import CADDBPE from "../screens/Modules/cadd/screens/bpe/index";
import CADDGM from "../screens/Modules/cadd/screens/gm/index";
import CADDGO from "../screens/Modules/cadd/screens/go/index";
import CADDIM from "../screens/Modules/cadd/screens/im/index";
import CADDSCI from "../screens/Modules/cadd/screens/sci/index";
import CADDStakeholder from "../screens/Modules/cadd/screens/stakeholder/index";
import CADDStakeholderInfo from "../screens/Modules/cadd/screens/stakeholder/info";
import CADDScp from "../screens/Modules/cadd/screens/scp/index";
import CADDScpInfo from "../screens/Modules/cadd/screens/scp/info";
import CADDScl from "../screens/Modules/cadd/screens/scl/index";
import CADDSclInfo from "../screens/Modules/cadd/screens/scl/info";
import CADDVillage from "../screens/Modules/cadd/screens/villages/index";
import CADDLocations from "../screens/Modules/cadd/screens/locations/index";
import CADDLocationsInfo from "../screens/Modules/cadd/screens/locations/info";
import CADDEvents from "../screens/Modules/cadd/screens/events/index";
import CADDEventsInfo from "../screens/Modules/cadd/screens/events/info";
import CADDDocuments from "../screens/Modules/cadd/screens/documents/index";
import CADDProjectPublications from '../screens/Modules/cadd/screens/projects/publications';
import RISK from "../screens/Modules/cadd/screens/risk/index";
import SHIPMENT from "../screens/Modules/cadd/screens/shipments/index";
import CADDUSERS from "../screens/Modules/cadd/screens/users/index";
import CADDDUEDILIGINCE from "../screens/Modules/cadd/screens/due-diligence/index";
import CADDLIR from "../screens/Modules/cadd/screens/lir/index";
import CADDLIRInfo from "../screens/Modules/cadd/screens/lir/info";

// GLOBAL
import InformationSources from "../components/Forms/informationSources/index";
import InformationClients from "../components/Forms/informationClients/index";


import Admin from "../screens/Admin";
import Users from "../screens/Admin/users";
import AdminDashboard from "../screens/Admin/dashboard";
import PMEDashboard from "../screens/Modules/pme/screens/dashboard";
import { TIFDashboard } from "../screens/Modules/tif/index";
import CADDDashboard from "../screens/Modules/cadd/screens/dashboard";
import Update from '../screens/Admin/update';

import PMEDocuments from "../screens/Modules/pme/screens/documents";
import PMEDocumentInfo from '../screens/Modules/pme/screens/documents/info';
import PMEIncidents from "../screens/Modules/pme/screens/incidents";
import PMECorrectiveActions from "../screens/Modules/pme/screens/corrective-actions";
import CADDIncidents from "../screens/Modules/cadd/screens/incidents";
import CADDCorrectiveActions from "../screens/Modules/cadd/screens/corrective-actions";
import { PMESettingsEdit, PMESettingsView } from "../screens/Modules/pme/screens/settings";
import { CADDSettingsEdit, CADDSettingsView } from "../screens/Modules/cadd/screens/settings";
import { checkPermission } from "../permissions/usePermissions";
import { isSuperAdmin } from "../constants/user";
import { AdminSettingsEdit, AdminSettingsView } from "../screens/Modules/admin/screens/settings";
import TIF from "../screens/Modules/tif";
import { TIFSettingsEdit, TIFSettingsView } from "../screens/Modules/tif/screens/settings";
import TIFStakeholder from "../screens/Modules/tif/screens/stakeholder";
import TIFUsers from "../screens/Modules/tif/screens/users";
import TIFMineSites from "../screens/Modules/tif/screens/scl";
import TIFLocations from "../screens/Modules/tif/screens/locations";
import TIFVillages from "../screens/Modules/tif/screens/villages";
import TIFScp from "../screens/Modules/tif/screens/scp";
import TIFLIR from "../screens/Modules/tif/screens/lir";
import TIFEvents from "../screens/Modules/tif/screens/events";
import TIFIncidents from "../screens/Modules/tif/screens/incidents";
import TIFCorrectiveActions from "../screens/Modules/tif/screens/corrective-actions";
import TIFDocuments from "../screens/Modules/tif/screens/documents";
import TIFMineOperators from "../screens/Modules/tif/screens/mine-operators";
import TIFAmp from "../screens/Modules/tif/screens/amp";
import DataStore from "../screens/DataStore";
import FindInformation from "../screens/FindInformation";
import InformationChannels from "../screens/InformationChannels";
import DataStoreTable from "../screens/DataStore/DataStoreTable";
import DataStoreView from "../screens/DataStore/DataStoreView";
import InformationChannel from "../screens/InformationChannels/InformationChannel";
import Subject from "../screens/InformationChannels/Subject";
import DataPoint from "../screens/InformationChannels/DataPoint";
import FindInformationSource from "../screens/FindInformation/Source";
import FindInformationSubject from "../screens/FindInformation/Subject";
import TIFPrograms from "../screens/Modules/tif/screens/programs";

import { TAZAMADashboard } from "../screens/Modules/tazama";
import Tazama from "../screens/Modules/tazama";
import TAZAMAProfile from "../screens/Modules/tazama/screens/profile/index";
import { TAZAMASettingsEdit, TAZAMASettingsView } from "../screens/Modules/tazama/screens/settings";
import TAZAMAUsers from "../screens/Modules/tazama/screens/users";
import TAZAMAEvents from "../screens/Modules/tazama/screens/events/events";
import TAZAMACorrectiveActions from "../screens/Modules/tazama/screens/corrective-actions";
import TAZAMAIncidents from "../screens/Modules/tazama/screens/incidents";
import TAZAMAPartners from "../screens/Modules/tazama/screens/partners";
import ViewTIF from "../screens/ViewTIF";
import EditTIF from "../screens/EditTIF";
import TAZAMAInitiatives from "../screens/Modules/tazama/screens/linked-subjects/initiatives";
import TAZAMAVictims from "../screens/Modules/tazama/screens/linked-subjects/victims";
import TAZAMALocations from "../screens/Modules/tazama/screens/linked-subjects/locations";
import TAZAMAStakeholders from "../screens/Modules/tazama/screens/linked-subjects/stakeholders";
import TAZAMAPictures from "../screens/Modules/tazama/screens/linked-subjects/pictures";
import TAZAMADocuments from "../screens/Modules/tazama/screens/linked-subjects/documents";
import TAZAMATestimonials from "../screens/Modules/tazama/screens/testimonials";

const demo = process.env.REACT_APP_ENV === 'demo';
const TIF_MODULE = 'tif';
const TAZAMA_MODULE = 'tazama';
const PME_MODULE = 'pme';
const CADD_MODULE = 'cadd';

const privateRouts = [
  {
    path: "/app",
    key: "APP_ROOT",
    exact: true,
    visible: () => {
      return true;
    },
    component: <Home />,
  },
  {
    path: "/app/cadd",
    key: "APP_CADD_ROOT",
    component: <Cadd />,
    routes: [
      {
        path: "/app/cadd",
        key: "APP_CADD_DASHBOARD",
        exact: true,
        visible: (user) => {
          return true;
        },
        component: <CADDDashboard />,
      },
      {
        path: '/app/cadd/view/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'CADD_VIEW',
        component: <View />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/cadd/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'CADD_VIEW_DD',
        component: <ViewCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/cadd/analysis/:namespace/:id?/:sourceId?',
        key: 'CADD_ANALYSIS',
        component: <Analysis />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/cadd/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'CADD_EDIT',
        component: <Edit />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/cadd/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'CADD_EDIT_DD',
        component: <EditCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/documents",
        key: "CADD_DOCUMENTS",
        component: <CADDDocuments />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/profile",
        key: "CADD_PROFILE",
        setting: true,
        component: <Profile />,
        exact: true,
        visible: (user) => {
          return true;
        }
      },
      {
        path: "/app/cadd/edit/settings",
        key: "CADD_VIEW_SETTINGS",
        setting: true,
        component: <CADDSettingsEdit />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canEdit', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/view/settings",
        key: "CADD_EDIT_SETTINGS",
        setting: true,
        component: <CADDSettingsView />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/kyc",
        key: "CADD_KYC",
        component: <KYC />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'myOrganisation.KYC.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/projects",
        key: "CADD_PROJECTS",
        component: <CADDProjects />,
        setting: true,
        exact: true,
        visible: (user) => {
          return !user.companyId && !demo;
        }
      },
      {
        path: "/app/cadd/projects/:tab",
        key: "CADD_PROJECTS",
        component: <CADDProjects />,
        setting: true,
        exact: true,
        visible: (user) => {
          return !demo && checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/cadd/project/:id/kyc/:userId",
        key: "CADD_PROJECT_INFO",
        setting: true,
        component: <CADDProjectKYC />,
        exact: true,
        visible: (user) => {
          return !user?.company?.id && !demo && checkPermission({ permission: 'myOrganisation.KYC.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/cadd/project/:id",
        key: "CADD_PROJECT_INFO",
        setting: true,
        component: <CADDProjectInfo />,
        exact: true,
        visible: (user) => {
          return !user?.company?.id && !demo && checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/cadd/projects/edit",
        key: "CADD_PROJECTS_EDIT",
        setting: true,
        component: <CADDProjects />,
        exact: true,
        visible: (user) => {
          return !user?.company?.id && !demo && checkPermission({ permission: 'projects.canEdit', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/cadd/compliance-report",
        key: "CADD_COMPLIANCE_REPORT",
        component: <CADDComplianceReport />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/scp",
        key: "CADD_STAKEHOLDERS",
        component: <CADDScp />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/scp/:id",
        key: "CADD_STAKEHOLDER_INFO",
        component: <CADDScpInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/stakeholders",
        key: "CADD_STAKEHOLDERS",
        component: <CADDStakeholder />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/stakeholders/:id",
        key: "CADD_STAKEHOLDER_INFO",
        component: <CADDStakeholderInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/scl",
        key: "CADD_SITES",
        component: <CADDScl />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/scl/:id",
        key: "CADD_SITES_INFO",
        component: <CADDSclInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/village",
        key: "CADD_VILLAGES",
        component: <CADDVillage />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.villages.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/locations",
        key: "CADD_SITES",
        component: <CADDLocations />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/locations/:id",
        key: "CADD_SITES_INFO",
        component: <CADDLocationsInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions });
        },
      },
      // {
      //   path: "/app/cadd/suppliers",
      //   key: "CADD_SUPPLIERS",
      //   component: CADDScp,
      //   exact: true,
      //    visible: () => {
      //      return true;
      //    },
      // },
      // {
      //   path: "/app/cadd/suppliers/:id",
      //   key: "CADD_SUPPLIERS_INFO",
      //   component: CADDScpInfo,
      //   exact: true,
      //    visible: () => {
      //      return true;
      //    },
      // },
      {
        path: "/app/cadd/events",
        key: "CADD_EVENTS",
        component: <CADDEvents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/incidents",
        key: "CADD_INCIDENTS",
        component: <CADDIncidents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/corrective-actions",
        key: "CADD_CA",
        component: <CADDCorrectiveActions />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/events/:id",
        key: "CADD_EVENTS_INFO",
        component: <CADDEventsInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/supply-chain-policy",
        key: "CADD_SUPPLY_CHAIN_POLICY",
        component: <CADDSupplyPolicy />,
        exact: true,
        visible: (user) => {
          return true;
        },
      },
      {
        path: "/app/cadd/management-systems",
        key: "CADD_IM",
        component: <CADDIM />,
        exact: true,
        visible: (user) => {
          return true;
        },
      },
      {
        path: "/app/cadd/supply-chain-integrity",
        key: "CADD_SCI",
        component: <CADDSCI />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/partner-engagement",
        key: "CADD_BPE",
        component: <CADDBPE />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/grievance-mechanism",
        key: "CADD_GM",
        component: <CADDGM />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/governance",
        key: "CADD_GO",
        component: <CADDGO />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/shipments",
        key: "CADD_SHIPMENTS",
        component: <SHIPMENT />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/risk",
        key: "CADD_RISK",
        component: <RISK />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/project/:id/publications",
        key: "CADD_PROJECT_PUBLICATIONS",
        setting: true,
        component: <CADDProjectPublications />,
        exact: true,
        visible: (user) => {
          return user?.company?.id && !demo && checkPermission({ permission: 'projects.canPublish', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/cadd/users",
        key: "CADD_USERS",
        setting: true,
        component: <CADDUSERS />,
        exact: true,
        visible: (user) => {
          // return !user?.company?.id && !demo;
          return !demo && checkPermission({ permission: 'users.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/cadd/due-diligence",
        key: "CADD_DUE_DILIGENCE_DOCS",
        component: <CADDDUEDILIGINCE />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/cadd/is",
        key: "CADD_INFORMATION_SOURCES",
        component: <InformationSources />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/ic",
        key: "CADD_INFORMATION_CLIENTS",
        component: <InformationClients />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/lir",
        key: "CADD_LIR",
        component: <CADDLIR />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/lir/:id",
        key: "CADD_LIR_INFO",
        component: <CADDLIRInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/cadd/data-store",
        key: "APP_TIF_DATASTORE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStore mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/data-store/:namespace",
        key: "APP_TIF_DATASTORE_NAMESPACE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreTable mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/data-store/:namespace/view/:id",
        key: "APP_TIF_DATASTORE_NAMESPACE_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/data-store/:namespace/view/:id/:group",
        key: "APP_TIF_DATASTORE_NAMESPACE_VIEW_GROUP",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/find-information",
        key: "APP_TIF_FIND_INFO",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformation mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/information-channels",
        key: "APP_TIF_INFO_CHANNELS",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannels mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/information-channels/:id",
        key: "APP_TIF_INFO_CHANNELS_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannel mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/information-channels/:id/:subjectId",
        key: "APP_TIF_INFO_CHANNELS_VIEW_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <Subject mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/information-channels/:id/:subjectId/:dataPointId",
        key: "APP_TIF_INFO_CHANNELS_VIEW_DATAPOINT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataPoint mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/find-information/:id",
        key: "APP_TIF_FIND_INFO_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSubject mod={CADD_MODULE} />,
      },
      {
        path: "/app/cadd/find-information/:id/:sourceId",
        key: "APP_TIF_FIND_INFO_SOURCE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSource mod={CADD_MODULE} />,
      },
    ],
  },
  {
    path: "/app/pme",
    key: "APP_PME_ROOT",
    component: <Pme />,
    visible: () => {
      return true;
    },
    routes: [
      {
        path: "/app/pme",
        key: "APP_PME_DASHBOARD",
        exact: true,
        visible: (user) => {
          return true;
        },
        component: <PMEDashboard />,
      },
      {
        path: '/app/pme/view/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'PME_VIEW',
        component: <View />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/pme/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'PME_VIEW_DD',
        component: <ViewCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/pme/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'PME_EDIT_DD',
        component: <EditCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/pme/analysis/:namespace/:id?/:sourceId?',
        key: 'PME_ANALYSIS',
        component: <Analysis />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/pme/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'PME_EDIT',
        component: <Edit />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/profile",
        key: "PME_PROFILE",
        setting: true,
        component: <PMEProfile />,
        exact: false,
        visible: (user) => {
          return true;
        }
      },
      {
        path: "/app/pme/edit/settings",
        key: "PME_EDIT_SETTINGS",
        setting: true,
        component: <PMESettingsEdit />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canEdit', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/view/settings",
        key: "PME_VIEW_SETTINGS",
        setting: true,
        component: <PMESettingsView />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/stakeholders",
        key: "PME_STAKEHOLDER",
        component: <PMEStakeholder />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/stakeholders/:id",
        key: "PME_STAKEHOLDER_INFO",
        component: <PMEStakeholderInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/lir",
        key: "PME_LIR",
        component: <PMELIR />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/lir/:id",
        key: "PME_LIR_INFO",
        component: <PMELIRInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/scp",
        key: "PME_SCP",
        component: <PMEScp />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/scp/:id",
        key: "PME_SCP_INFO",
        component: <PMEScpInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/scp/:id/locations",
        key: "PME_SCP_INFO_LOCATIONS",
        component: <PMEStakeholderLocations />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/scl",
        key: "PME_SCL",
        component: <PMEScl />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/scl/:id",
        key: "PME_SCL_INFO",
        component: <PMESclInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/village",
        key: "PME_VILLAGE",
        component: <PMEVillage />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.villages.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/village/:id",
        key: "PME_VILLAGE_INFO",
        component: <PMEVillageInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.villages.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/locations",
        key: "PME_LOCATIONS",
        component: <PMELocations />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/locations/:id",
        key: "PME_LOCATIONS_INFO",
        component: <PMELocationsInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/users",
        key: "PME_USERS",
        setting: true,
        component: <PMEUsers />,
        exact: true,
        visible: (user) => {
          // return !user?.company?.id && !demo;
          return !demo && checkPermission({ permission: 'users.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/pme/events",
        key: "PME_EVENTS",
        component: <PMEEvents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/incidents",
        key: "PME_INCIDENTS",
        component: <PMEIncidents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/corrective-actions",
        key: "PME_CA",
        component: <PMECorrectiveActions />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/events/:id",
        key: "PME_EVENTS_INFO",
        component: <PMEEventsInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/documents",
        key: "PME_DOCUMENTS",
        component: <PMEDocuments />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/documents/:id",
        key: "PME_DOCUMENTS_INFO",
        component: <PMEDocumentInfo />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/is",
        key: "PME_INFORMATION_SOURCES",
        component: <InformationSources />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/ic",
        key: "PME_INFORMATION_CLIENTS",
        component: <InformationClients />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/projects",
        key: "PME_PROJECTS",
        setting: true,
        component: <PMEProjects />,
        exact: true,
        visible: (user) => {
          return !user.companyId && !demo;
        }
      },
      {
        path: "/app/pme/projects/:tab",
        key: "PME_PROJECTS",
        setting: true,
        component: <PMEProjects />,
        exact: true,
        visible: (user) => {
          return !demo && checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/pme/projectload",
        key: "PME_PROJECTS_LOAD",
        setting: true,
        component: <PMEProjectLoad />,
        exact: true,
        visible: (user) => {
          return !user?.company?.id && !demo && checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/pme/project/:id",
        key: "PME_PROJECT_INFO",
        setting: true,
        component: <PMEProjectInfo />,
        exact: true,
        visible: (user) => {
          return !user?.company?.id && !demo && checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/pme/project/:id/publications",
        key: "PME_PROJECT_PUBLICATIONS",
        setting: true,
        component: <PMEProjectPublications />,
        exact: true,
        visible: (user) => {
          return user?.company?.id && !demo && checkPermission({ permission: 'projects.canPublish', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/pme/due-diligence",
        key: "PME_DUE_DILIGENCE_DOCS",
        component: <PMEDUEDILIGINCE />,
        exact: true,
        visible: () => {
          return true;
        },
      },
      {
        path: "/app/pme/data-store",
        key: "APP_TIF_DATASTORE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStore mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/data-store/:namespace",
        key: "APP_TIF_DATASTORE_NAMESPACE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreTable mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/data-store/:namespace/view/:id",
        key: "APP_TIF_DATASTORE_NAMESPACE_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/data-store/:namespace/view/:id/:group",
        key: "APP_TIF_DATASTORE_NAMESPACE_VIEW_GROUP",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/find-information",
        key: "APP_TIF_FIND_INFO",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformation mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/information-channels",
        key: "APP_TIF_INFO_CHANNELS",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannels mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/information-channels/:id",
        key: "APP_TIF_INFO_CHANNELS_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannel mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/information-channels/:id/:subjectId",
        key: "APP_TIF_INFO_CHANNELS_VIEW_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <Subject mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/information-channels/:id/:subjectId/:dataPointId",
        key: "APP_TIF_INFO_CHANNELS_VIEW_DATAPOINT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataPoint mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/find-information/:id",
        key: "APP_TIF_FIND_INFO_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSubject mod={PME_MODULE} />,
      },
      {
        path: "/app/pme/find-information/:id/:sourceId",
        key: "APP_TIF_FIND_INFO_SOURCE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSource mod={PME_MODULE} />,
      },
    ],
  },
  {
    path: "/app/tif",
    key: "APP_TIF_ROOT",
    component: <TIF />,
    visible: () => {
      return true;
    },
    routes: [
      {
        path: "/app/tif",
        key: "APP_TIF_DASHBOARD",
        exact: true,
        visible: (user) => {
          return true;
        },
        component: <TIFDashboard />,
      },
      {
        path: '/app/tif/view/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'TIF_VIEW',
        component: <View />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/tif/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'TIF_VIEW_DD',
        component: <ViewCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/tif/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'TIF_EDIT_DD',
        component: <EditCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/tif/analysis/:namespace/:id?/:sourceId?',
        key: 'TIF_ANALYSIS',
        component: <Analysis />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/tif/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'TIF_EDIT',
        component: <Edit />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/profile",
        key: "TIF_PROFILE",
        setting: true,
        component: <TIFProfile />,
        exact: false,
        visible: (user) => {
          return true;
        }
      },
      {
        path: "/app/tif/edit/settings",
        key: "TIF_EDIT_SETTINGS",
        setting: true,
        component: <TIFSettingsEdit />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canEdit', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/view/settings",
        key: "TIF_VIEW_SETTINGS",
        setting: true,
        component: <TIFSettingsView />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/scp",
        key: "TIF_STAKEHOLDERS",
        component: <TIFScp />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/lir",
        key: "TIF_LIR",
        component: <TIFLIR />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.LIR.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/stakeholders",
        key: "TIF_STAKEHOLDER",
        component: <TIFStakeholder />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'stakeholders.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/scl",
        key: "TIF_SITES",
        component: <TIFMineSites />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.mineSites.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/village",
        key: "TIF_VILLAGES",
        component: <TIFVillages />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.villages.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/locations",
        key: "TIF_SITES",
        component: <TIFLocations />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'locations.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/events",
        key: "TIF_EVENTS",
        component: <TIFEvents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/incidents",
        key: "TIF_INCIDENTS",
        component: <TIFIncidents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/corrective-actions",
        key: "TIF_CA",
        component: <TIFCorrectiveActions />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/documents",
        key: "TIF_DOCUMENTS",
        component: <TIFDocuments />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'documents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/users",
        key: "TIF_USERS",
        setting: true,
        component: <TIFUsers />,
        exact: true,
        visible: (user) => {
          // return !user?.company?.id && !demo;
          return !demo && checkPermission({ permission: 'users.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/pme/is",
        key: "PME_INFORMATION_SOURCES",
        component: <InformationSources />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/pme/ic",
        key: "PME_INFORMATION_CLIENTS",
        component: <InformationClients />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'projects.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tif/mine-operators",
        key: "TIF_MINE_OPERATORS",
        component: <TIFMineOperators />,
        exact: true,
        visible: (user) => {
          // TO-DO add permissions
          // return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
          return true;
        },
      },
      {
        path: "/app/tif/programs",
        key: "TIF_AMP",
        component: <TIFPrograms />,
        exact: true,
        visible: (user) => {
          // TO-DO add permissions
          // return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
          return true;
        },
      },
      {
        path: "/app/tif/amp",
        key: "TIF_AMP",
        component: <TIFAmp />,
        exact: true,
        visible: (user) => {
          // TO-DO add permissions
          // return checkPermission({ permission: 'stakeholders.SCA.canView', permissions: user?.role?.permissions });
          return true;
        },
      },
      {
        path: "/app/tif/data-store",
        key: "APP_TIF_DATASTORE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStore mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/data-store/:namespace",
        key: "APP_TIF_DATASTORE_NAMESPACE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreTable mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/data-store/:namespace/view/:id",
        key: "APP_TIF_DATASTORE_NAMESPACE_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/data-store/:namespace/view/:id/:group",
        key: "APP_TIF_DATASTORE_NAMESPACE_VIEW_GROUP",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/find-information",
        key: "APP_TIF_FIND_INFO",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformation mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/information-channels",
        key: "APP_TIF_INFO_CHANNELS",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannels mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/information-channels/:id",
        key: "APP_TIF_INFO_CHANNELS_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannel mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/information-channels/:id/:subjectId",
        key: "APP_TIF_INFO_CHANNELS_VIEW_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <Subject mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/information-channels/:id/:subjectId/:dataPointId",
        key: "APP_TIF_INFO_CHANNELS_VIEW_DATAPOINT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataPoint mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/find-information/:id",
        key: "APP_TIF_FIND_INFO_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSubject mod={TIF_MODULE} />,
      },
      {
        path: "/app/tif/find-information/:id/:sourceId",
        key: "APP_TIF_FIND_INFO_SOURCE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSource mod={TIF_MODULE} />,
      },
    ],
  },
  {
    path: "/app/tazama",
    key: "APP_TAZAMA_ROOT",
    component: <Tazama />,
    visible: () => {
      return true;
    },
    routes: [
      {
        path: "/app/tazama/events",
        key: "tazama_EVENTS",
        component: <TAZAMAEvents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tazama/partners",
        key: "partners_INCIDENTS",
        component: <TAZAMAPartners />,
        exact: true,
        visible: (user) => {
          // return checkPermission({ permission: 'events.partners.canView', permissions: user?.role?.permissions });
          return true;
        },
      },
      {
        path: "/app/tazama/incidents",
        key: "tazama_INCIDENTS",
        component: <TAZAMAIncidents />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.incidents.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tazama/corrective-actions",
        key: "tazama_CA",
        component: <TAZAMACorrectiveActions />,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tazama/testimonials",
        key: "tazama_testimonials",
        component: <TAZAMATestimonials />,
        exact: true,
        visible: (user) => {
          // return checkPermission({ permission: 'events.correctiveActions.canView', permissions: user?.role?.permissions });
          // TODO: check this
          return true;
        },
      },
      {
        path: "/app/tazama/initiatives",
        key: "tazama_INITIATIVES",
        component: <TAZAMAInitiatives />,
        exact: true,
        visible: (user) => {
          // TODO: fix this
          return true;
        },
      },
      {
        path: "/app/tazama/victims",
        key: "tazama_VICTIMS",
        component: <TAZAMAVictims />,
        exact: true,
        visible: (user) => {
          // TODO: fix this
          return true;
        },
      },
      {
        path: "/app/tazama/stakeholders",
        key: "tazama_STAKEHOLDERS",
        component: <TAZAMAStakeholders />,
        exact: true,
        visible: (user) => {
          // TODO: fix this
          return true;
        },
      },
      {
        path: "/app/tazama/pictures",
        key: "tazama_pictures",
        component: <TAZAMAPictures />,
        exact: true,
        visible: (user) => {
          // TODO: fix this
          return true;
        },
      },
      {
        path: "/app/tazama/documents",
        key: "tazama_documents",
        component: <TAZAMADocuments />,
        exact: true,
        visible: (user) => {
          // TODO: fix this
          return true;
        },
      },
      {
        path: "/app/tazama/locations",
        key: "tazama_LOCATIONS",
        component: <TAZAMALocations />,
        exact: true,
        visible: (user) => {
          // TODO: fix this
          return true;
        },
      },
      {
        path: "/app/tazama",
        key: "APP_TAZAMA_DASHBOARD",
        exact: true,
        visible: (user) => {
          return true;
        },
        component: <TAZAMADashboard />,
      },
      {
        path: '/app/tazama/view/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'tazama_VIEW',
        component: <ViewTIF />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          // return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
          return true;
        },
      },

      {
        path: '/app/tazama/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?',
        key: 'tazama_VIEW_DD',
        component: <ViewCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/tazama/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'tazama_EDIT_DD',
        component: <EditCADD />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: '/app/tazama/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
        key: 'tazama_EDIT',
        component: <EditTIF />,
        hideSource: true,
        exact: true,
        visible: (user) => {
          return checkPermission({ permission: 'forms.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tazama/profile",
        key: "tazama_PROFILE",
        setting: true,
        component: <TAZAMAProfile />,
        exact: false,
        visible: (user) => {
          return true;
        }
      },
      {
        path: "/app/tazama/edit/settings",
        key: "tazama_EDIT_SETTINGS",
        setting: true,
        component: <TAZAMASettingsEdit />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canEdit', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tazama/view/settings",
        key: "tazama_VIEW_SETTINGS",
        setting: true,
        component: <TAZAMASettingsView />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/tazama/users",
        key: "tazama_USERS",
        setting: true,
        component: <TAZAMAUsers />,
        exact: true,
        visible: (user) => {
          // return !user?.company?.id && !demo;
          return !demo && checkPermission({ permission: 'users.canView', permissions: user?.role?.permissions });
        }
      },
      {
        path: "/app/tazama/data-store",
        key: "APP_tazama_DATASTORE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStore mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/data-store/:namespace",
        key: "APP_tazama_DATASTORE_NAMESPACE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreTable mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/data-store/:namespace/view/:id",
        key: "APP_tazama_DATASTORE_NAMESPACE_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/data-store/:namespace/view/:id/:group",
        key: "APP_tazama_DATASTORE_NAMESPACE_VIEW_GROUP",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataStoreView mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/find-information",
        key: "APP_tazama_FIND_INFO",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformation mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/information-channels",
        key: "APP_tazama_INFO_CHANNELS",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannels mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/information-channels/:id",
        key: "APP_tazama_INFO_CHANNELS_VIEW",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <InformationChannel mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/information-channels/:id/:subjectId",
        key: "APP_tazama_INFO_CHANNELS_VIEW_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <Subject mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/information-channels/:id/:subjectId/:dataPointId",
        key: "APP_tazama_INFO_CHANNELS_VIEW_DATAPOINT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <DataPoint mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/find-information/:id",
        key: "APP_tazama_FIND_INFO_SUBJECT",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSubject mod={TAZAMA_MODULE} />,
      },
      {
        path: "/app/tazama/find-information/:id/:sourceId",
        key: "APP_tazama_FIND_INFO_SOURCE",
        exact: true,
        visible: (user) => {
          return true; // TODO: fix this
        },
        component: <FindInformationSource mod={TAZAMA_MODULE} />,
      },
    ],
  },
  {
    path: "/app/admin",
    key: "APP_ADMIN_ROOT",
    component: <Admin />,
    routes: [
      {
        path: "/app/admin/edit/settings",
        key: "ADMIN_EDIT_SETTINGS",
        // setting: true,
        component: <AdminSettingsEdit />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canEdit', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/admin/view/settings",
        key: "ADMIN_VIEW_SETTINGS",
        // setting: true,
        component: <AdminSettingsView />,
        exact: false,
        visible: (user) => {
          return checkPermission({ permission: 'settings.canView', permissions: user?.role?.permissions });
        },
      },
      {
        path: "/app/admin",
        key: "APP_ADMIN_DASHBOARD",
        exact: true,
        visible: (user) => {
          return user && isSuperAdmin(user) ? true : false;
        },
        component: <AdminDashboard />,
      },
      {
        path: "/app/admin/users",
        key: "APP_ADMIN_USERS",
        exact: true,
        visible: (user) => {
          return user && isSuperAdmin(user) ? true : false;
        },
        component: <Users />,
      },
      {
        path: "/app/admin/update/:entity",
        key: "APP_ADMIN_UPDATE",
        exact: true,
        visible: (user) => {
          return user && isSuperAdmin(user) ? true : false;
        },
        component: <Update />,
      },
    ],
  },
];
export default privateRouts;
